/*
 * @Description: 评价相关
 * @Author: wangbo16
 * @Date: 2021-08-23 15:02:33
 * @LastEditors: wangbo16
 * @LastEditTime: 2021-08-27 12:12:24
 */
import {
  IOption,
  ICreateBody,
  ICommentStats,
  ICommentList,
  IGetCommentsReq,
  IUnCommentInfo
} from '@/schemas/comment';
import { IPageList } from '@/schemas/common';
import { request } from './request';
import { ApiConfigs, Response } from '../schemas/service';

const api: ApiConfigs = {
  getCommentOptions: {
    url: '/health/api/v1/evaluate/queryStarList',
    method: 'GET'
  },
  createComment: {
    url: '/health/api/v1/evaluate/evaluateSubmit',
    method: 'POST'
  },
  getDoctorCommentStats: {
    url: '/health/api/v1/evaluate/queryEvaluateData',
    method: 'GET'
  },
  queryDoctorComment: {
    url: '/health/api/v1/evaluate/queryEvaluateList',
    method: 'GET'
  },
  queryUnCommetInfo: {
    url: '/health/api/v1/evaluate/queryNotEvaluated',
    method: 'GET'
  }
};

const comments = {
  async getCommentOptions() {
    try {
      const response: Response<IOption[] | null> = await request(
        api.getCommentOptions,
        undefined,
        undefined,
        {
          hideGlobalLoading: false
        }
      );
      const { result } = response;
      if (result) {
        return result;
      }
      return Promise.reject();
    } catch (error) {
      return Promise.reject(error);
    }
  },

  async createComment(body: ICreateBody) {
    try {
      const response: Response = await request(
        api.createComment,
        undefined,
        { ...body },
        {
          hideGlobalLoading: false
        }
      );
      const { result } = response;
      if (result) {
        return result;
      }
      return Promise.reject();
    } catch (error) {
      return Promise.reject(error);
    }
  },

  async getDoctorCommentStats(doctorId) {
    try {
      const response: Response<ICommentStats> = await request(
        api.getDoctorCommentStats,
        {
          doctorId
        },
        undefined,
        {
          hideGlobalLoading: false
        }
      );
      const { result } = response;
      if (result) {
        return result;
      }
      return Promise.reject();
    } catch (error) {
      return Promise.reject(error);
    }
  },

  async getDoctorComment({
    doctorId,
    pageNum = 1,
    pageSize = 10,
    tagId = undefined
  }: IGetCommentsReq) {
    const response: Response = await request(
      api.queryDoctorComment,
      {
        doctorId,
        tagId,
        pageNum,
        pageSize
      },
      undefined,
      {
        hideGlobalLoading: true
      }
    );
    const { result } = response;
    let list: ICommentList = [];
    if (result?.list) {
      list = result.list.map((comment) => {
        const {
          commentContent: content,
          starLevel: rate,
          userName: author,
          tagContents: tags,
          showDate: datetime
        } = comment;
        return {
          author,
          rate,
          datetime,
          tags: tags || [],
          content
        };
      });
    }
    result.list = list;
    return result as IPageList<ICommentList>;
  },

  async queryUnCommetInfo(doctorId: number | string) {
    try {
      const response: Response<IUnCommentInfo | null> = await request(
        api.queryUnCommetInfo,
        { doctorId },
        undefined,
        {
          hideGlobalLoading: false
        }
      );
      const { result } = response;
      if (result?.orderId) {
        return result.orderId;
      }
      return Promise.reject();
    } catch (error) {
      return Promise.reject(error);
    }
  }
};

export default comments;
